import { render } from "./MappingBlocks.vue?vue&type=template&id=2cd4396c&ts=true"
import script from "./MappingBlocks.vue?vue&type=script&lang=ts"
export * from "./MappingBlocks.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__